import { Box, Image, Stack, styled } from "@tm/components"
import { getComponentFromBundle } from "@tm/utils"
import DirectSearchWidgetComponent from "../../../../../../parts/src/components/direct-search-widget"
import UniSearchWidgetComponent from "../../../../../../parts/src/components/uni-search-widget"
import { WidgetStart as CustomerSearchWidget } from "../../../../../../crm/src"
import VehicleWidget from "../../../../../../vehicle/src/components/widget/component"
import { WidgetBundle as VoucherWidgetBundle } from "../../../../../../vouchers/src"
import { startTemplateElekatChannel } from "./channel"

// Styled Components

export const ColumnBox = styled(Box)(() => ({
    display: "flex",
    overflow: "hidden",
}))

export const LogoLandingPage = styled("img")(() => ({
    height: "140px",
    padding: "40px 0 0 36px",
    objectFit: "contain",
    objectPosition: "left",
}))

export const MoodPicture = styled(Box, { shouldForwardProp: (prop) => prop !== "imageUrl" })<{ imageUrl?: string }>(({ imageUrl }) => ({
    backgroundImage: `url(${imageUrl})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "right top",
    width: "100%",
    height: "100%",
}))

export const RowStack = styled(Stack)(() => ({
    flex: "1",
    overflow: "auto",
}))

export const RightRow = styled(Box)(() => ({
    width: "592px",
    height: "100%",
    overflow: "auto",
}))

export const StyledStack = styled(Stack)(() => ({
    backgroundColor: "white",
    width: "100%",

    ".widget__card": {
        border: "none",
        background: "none",

        "&::before": {
            border: "none",
        },

        "&:hover": {
            background: "none",
            boxShadow: "none",
        },
    },
}))

// Styled Widgets
const DirectSearchWidget = getComponentFromBundle(DirectSearchWidgetComponent, startTemplateElekatChannel)
const UniSearchWidget = getComponentFromBundle(UniSearchWidgetComponent, startTemplateElekatChannel)
const VoucherWidget = getComponentFromBundle(VoucherWidgetBundle, startTemplateElekatChannel)

export const StyledDirectSearchWidget = styled(DirectSearchWidget)(() => ({
    flexDirection: "column",
}))

export const StyledUniSearchWidget = styled(UniSearchWidget)(() => ({
    width: "100%",
    padding: 0,
    height: "64px",

    "&.widget": {
        "& .widget__card": {
            padding: 0,

            "& .widget__inner": {
                "& .widget__header, .widget__content .label": {
                    display: "none",
                },
            },
        },
    },
}))

export const StyledCustomerSearchWidget = styled(CustomerSearchWidget)(() => ({
    "& .widget__inner": {
        padding: 0,

        "& .widget__header": {
            marginBottom: 0,
        },

        "& .line, .btn-container, .search-container .label": {
            display: "none",
        },
    },

    width: "100%",
    height: "20%",
    padding: 0,
}))

export const StyledVehicleWidget = styled(VehicleWidget)(() => ({
    width: "100%",

    "&.widget": {
        padding: 0,

        "& .widget__inner": {
            padding: 0,
        },
    },

    "&.widget--h2": {
        height: "64px",
    },

    "& .widget__header": {
        display: "none",
    },

    "& .widget__content": {
        "& .category-selection": {
            display: "none",
        },
    },

    "& .widget__footer": {
        display: "none",
    },
}))

export const StyledVoucherWidget = styled(VoucherWidget)(() => ({
    width: "100%",
    
    "& .widget__card": {
        height: "460px",
    }
}))
